import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import AccountHome from "../views/AccountHome";
import MyPayments from "../views/MyPayments";

export default function Account(props) {

	const appContext = useContext(AppContext);
	const [view, setView] = useState(null);

	async function init() {
		//run initializations here
	}

	function getView() {
		if (
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <AccountHome />
		} else if (
			appContext.navSubItem === "my-payments" &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <MyPayments />
		}

		return null;
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		const _view = getView();
		if (_view) {
			setView(_view);
		}
	}, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem])

	return view;
}
